import Modal from '@/components/modals/modal/modal.vue'
import IcWarning2 from '@/assets/svg/ic-warning-2.svg?inline'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'ConfirmEncashmentModal',
  props: {
    encashment: {
      type: Object
    }
  },
  components: {
    Modal,
    IcWarning2
  },
  methods: {
    numberWithSeparator,
    
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    onCancel() {
      this.$emit('cancel-encashment', this.encashment.encashment_id)
      this.hide()
    }
  }
}